import React from "react";

const AuthContext = React.createContext({user: {roles: []}});

export default AuthContext;
